import { render, staticRenderFns } from "./BranchUser.vue?vue&type=template&id=bc3870a4&scoped=true&lang=pug&"
import script from "./BranchUser.vue?vue&type=script&lang=ts&"
export * from "./BranchUser.vue?vue&type=script&lang=ts&"
import style0 from "./BranchUser.vue?vue&type=style&index=0&id=bc3870a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3870a4",
  null
  
)

export default component.exports